module.exports = __webpack_public_path__ + "static/media/20.21c1a550.png";